import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { queryClient } from 'providers';

const { sendInvoice } = TransectionApiServices();

export const useSendInvoice = (id: any) => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return sendInvoice(id, payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("invoice has been send successfully!!");
            },
        },
    );
};
